/* assets/ci-gallery.js
   Filmstrip drag-to-scroll that does NOT break page vertical scrolling.
*/

(() => {
  function initRail(rail) {
    if (!rail || rail.dataset.ciInit === "1") return;
    rail.dataset.ciInit = "1";

    // Prevent native image dragging interfering with pointer drag
    rail.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
    });

    let isDown = false;
    let didDrag = false;

    let startX = 0;
    let startY = 0;
    let startLeft = 0;

    // Only start “drag scrolling” when movement is clearly horizontal
    const ACTIVATE_PX = 6;

    // Make sure touch devices can still scroll the page vertically
    rail.style.touchAction = "pan-y";

    function onPointerDown(e) {
      // Only left click for mouse
      if (e.pointerType === "mouse" && e.button !== 0) return;

      // Don’t start drag from interactive/selection areas
      if (e.target.closest("a, button, input, textarea, select, .rte")) return;

      isDown = true;
      didDrag = false;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = rail.scrollLeft;

      rail.classList.add("is-pointer-down");
    }

    function onPointerMove(e) {
      if (!isDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      // If user is mostly moving vertically, do NOTHING (let page scroll)
      if (!didDrag) {
        if (Math.abs(dx) < ACTIVATE_PX && Math.abs(dy) < ACTIVATE_PX) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          // vertical intent -> abandon drag mode
          isDown = false;
          rail.classList.remove("is-pointer-down");
          return;
        }
        didDrag = true;

        // Once we commit to horizontal drag, capture the pointer so movement stays consistent
        try { rail.setPointerCapture(e.pointerId); } catch (_) {}
        rail.classList.add("is-dragging");
      }

      rail.scrollLeft = startLeft - dx;

      // Only prevent default AFTER horizontal drag mode is active
      // This avoids breaking vertical page scrolling.
      e.preventDefault();
    }

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;

      rail.classList.remove("is-pointer-down");
      rail.classList.remove("is-dragging");

      // If user dragged, suppress accidental click-through
      if (didDrag) {
        const killClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
        };
        rail.addEventListener("click", killClick, { capture: true, once: true });
      }
    }

    rail.addEventListener("pointerdown", onPointerDown, { passive: true });
    rail.addEventListener("pointermove", onPointerMove, { passive: false });
    rail.addEventListener("pointerup", endDrag, { passive: true });
    rail.addEventListener("pointercancel", endDrag, { passive: true });
    rail.addEventListener("pointerleave", endDrag, { passive: true });

    // Bonus: allow trackpad wheel to scroll horizontally when hovering the rail,
    // without hijacking normal vertical scrolling.
    rail.addEventListener(
      "wheel",
      (e) => {
        // If shift is pressed, browser already does horizontal scroll; don’t mess with it
        if (e.shiftKey) return;

        // If user is clearly trying to scroll horizontally (trackpad), help it a bit
        const absX = Math.abs(e.deltaX);
        const absY = Math.abs(e.deltaY);

        if (absX > absY) {
          // Horizontal intent: allow it naturally
          return;
        }

        // Vertical intent: do not block page scroll
      },
      { passive: true }
    );
  }

  function initAll() {
    document.querySelectorAll("[data-ci-rail]").forEach(initRail);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify theme editor / section re-render
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
})();
